import { render, staticRenderFns } from "./LayerLegend.vue?vue&type=template&id=b30b4262&scoped=true"
import script from "./LayerLegend.vue?vue&type=script&lang=ts"
export * from "./LayerLegend.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./LayerLegend.vue?vue&type=style&index=0&id=b30b4262&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "b30b4262",
  null
  ,true
)

export default component.exports